import * as wn from 'webnative'
export const DEFAULT_KEY_NAME = 'fil-cosigner'
export const DEFAULT_KEY_PERMISSION = wn.path.file('Keychain', DEFAULT_KEY_NAME)
